import { DocumentLink } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/DocumentLink';
import { ErrorContent } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/ErrorContent';
import { LanguageLink } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/LanguageLink';
import {
  GenerationFailedError,
  toEndUserError,
} from 'components/shared/Blotter/BlotterPanel/blotter-panel-document/hooks';
import { DocumentItem } from 'epic/common-form/Documentation';
import { useDownloadDlpDocument } from 'hooks/useDownloadDlpDocument';
import { useTranslation } from 'hooks/useTranslation';
import type { BlotterAnalyticCategory } from 'models/analytics';
import type { IBlotterItem } from 'models/IBlotterItem';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

type Props = {
  items: DocumentItem[];
  blotterItem: IBlotterItem;
  analyticsCategory: BlotterAnalyticCategory | undefined;
};

export function KidDocuments({ items, blotterItem: _blotterItem, analyticsCategory }: Props) {
  const label = useTranslation('blotterPanel.KidDocumentAccordionTitle');
  const errorMessage = useTranslation('downloadTermsheet.error');
  const { isDownloading, downloadDlpDocument, error: errorDlp } = useDownloadDlpDocument(errorMessage);

  return (
    <DocumentLink label={label}>
      {items.map((doc, index) => {
        if (isDownloading || doc.status === 'Pending') {
          return <LanguageLink key={index} langCode={doc.language} status="pending" />;
        }
        if (doc.status === 'Generation failed' || errorDlp) {
          return (
            <LanguageLink key={index} langCode={doc.language} status="error" severity="warning" onShowError={null}>
              <ErrorContent error={toEndUserError(errorDlp) ?? GenerationFailedError} severity="warning" />
            </LanguageLink>
          );
        }
        return (
          <LanguageLink
            key={index}
            langCode={doc.language}
            status="success"
            onDownload={() => {
              if (analyticsCategory !== undefined) {
                logAnalytics.trackEvent(analyticsCategory, 'Download KID language', doc.language);
              }
              if (doc.public === false) {
                downloadDlpDocument(doc.documentToken!);
              } else {
                window.open(doc.url, '_blank');
              }
            }}
          />
        );
      })}
    </DocumentLink>
  );
}
